import { PhonePipe } from '../../shared/pipes/phone.pipe';

export function phone ( phonePipe : PhonePipe ) {
  return ( value : string ) : string => phonePipe.transform(value);
}
